import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultaShopWindowComponent } from './consulta-shop-window.component';
import { HeaderModule } from 'src/app/shared/components/header/header.module';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { PriceTableModule } from 'src/app/shared/components/price-table/price-table.module';
import { ProductConsultaModule } from 'src/app/shared/components/product-consulta/product-consulta.module';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { MatDividerModule } from '@angular/material/divider';
import { ToggleModule } from 'src/app/shared/components/toggle/toggle.module';
import { ProductSelectorModule } from 'src/app/shared/components/product-selector/product-selector.module';
import { ProductAssinaturaModule } from 'src/app/shared/components/product-assinatura/product-assinatura.module';
import { CarouselSwiperConsultaModule } from 'src/app/shared/components/carousel-swiper-consulta/carousel-swiper-consulta.module';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { AssinaturaProductModule } from 'src/app/shared/components/assinatura-product/assinatura-product.module';
import { SwitchConsultaAssinaturaModule } from 'src/app/shared/components/switch-consulta-assinatura/switch-consulta-assinatura.module';
import { ConsultaProductSelectorModule } from 'src/app/shared/components/consulta-product-selector/consulta-product-selector.module';
import { PackagesMobileModule } from 'src/app/shared/components/packages-mobile/packages-mobile.module';



@NgModule({
  declarations: [
    ConsultaShopWindowComponent
  ],
  imports: [
    CommonModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    PriceTableModule,
    ProductConsultaModule,
    
    PaymentMethodsModule,
    MatDividerModule,
    ProductSelectorModule,
    ProductAssinaturaModule,
    CarouselSwiperConsultaModule,
    CarouselSwiperModule,
    AssinaturaProductModule,
    SwitchConsultaAssinaturaModule,
    ConsultaProductSelectorModule,
    PackagesMobileModule
  ],
  exports:[
    ConsultaShopWindowComponent
  ]
})
export class ConsultaShopWindowModule { }
